/**
 * @desc 供应商sku报价明细
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(params: API.srm.supplierInfo.getSupplierQuotation.Params, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/getSupplierQuotation`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
